"use strict";

var _classCallCheck = require("/github/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/github/workspace/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base64url_1 = __importDefault(require("base64url"));

var cryptoClients_1 = require("./cryptoClients");

var errors_1 = require("./errors");

function createSigningInput(payload, header) {
  var tokenParts = []; // add in the header

  var encodedHeader = base64url_1.default.encode(JSON.stringify(header));
  tokenParts.push(encodedHeader); // add in the payload

  var encodedPayload = base64url_1.default.encode(JSON.stringify(payload));
  tokenParts.push(encodedPayload); // prepare the message

  var signingInput = tokenParts.join('.'); // return the signing input

  return signingInput;
}

function createUnsecuredToken(payload) {
  var header = {
    typ: 'JWT',
    alg: 'none'
  };
  return createSigningInput(payload, header) + '.';
}

exports.createUnsecuredToken = createUnsecuredToken;

var TokenSigner =
/*#__PURE__*/
function () {
  function TokenSigner(signingAlgorithm, rawPrivateKey) {
    _classCallCheck(this, TokenSigner);

    if (!(signingAlgorithm && rawPrivateKey)) {
      throw new errors_1.MissingParametersError('a signing algorithm and private key are required');
    }

    if (typeof signingAlgorithm !== 'string') {
      throw new Error('signing algorithm parameter must be a string');
    }

    signingAlgorithm = signingAlgorithm.toUpperCase();

    if (!cryptoClients_1.cryptoClients.hasOwnProperty(signingAlgorithm)) {
      throw new Error('invalid signing algorithm');
    }

    this.tokenType = 'JWT';
    this.cryptoClient = cryptoClients_1.cryptoClients[signingAlgorithm];
    this.rawPrivateKey = rawPrivateKey;
  }

  _createClass(TokenSigner, [{
    key: "header",
    value: function header() {
      var _header = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var defaultHeader = {
        typ: this.tokenType,
        alg: this.cryptoClient.algorithmName
      };
      return Object.assign({}, defaultHeader, _header);
    }
  }, {
    key: "sign",
    value: function sign(payload) {
      var expanded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var customHeader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // generate the token header
      var header = this.header(customHeader); // prepare the message to be signed

      var signingInput = createSigningInput(payload, header);
      var signingInputHash = this.cryptoClient.createHash(signingInput); // sign the message and add in the signature

      var signature = this.cryptoClient.signHash(signingInputHash, this.rawPrivateKey);

      if (expanded) {
        return {
          'header': [base64url_1.default.encode(JSON.stringify(header))],
          'payload': JSON.stringify(payload),
          'signature': [signature]
        };
      } else {
        return [signingInput, signature].join('.');
      }
    }
  }]);

  return TokenSigner;
}();

exports.TokenSigner = TokenSigner;